<template>
  <div>
    <div class="d-flex align-items-center">
      <div class="mr-3">
        <span class="fa-stack">
          <i
            :class="['fas fa-circle fa-stack-2x', 'text-' + notification.data.variant]"
          ></i>
          <i :class="['fas', notification.data.icon, 'fa-stack-1x fa-inverse']"></i>
        </span>
      </div>
      <div style="white-space: initial">
        {{ notification.data.title }}
        <br />
        <small>{{ notification.data.text }}</small>
        <br />
        <small class="text-muted">{{
          notification.created_at | dateTimeRelative
        }}</small>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    notification: {},
  },
};
</script>

<style>
</style>